var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "create-vehicle-form" },
    [
      _c("h3", [_vm._v("\n        Fahrzeugdaten\n    ")]),
      _vm._v(" "),
      _c("div", { staticClass: "row mt-3" }, [
        _c(
          "div",
          { staticClass: "col-md-6" },
          [
            _c("csp-form-group-input", {
              attrs: { form: _vm.vehicleForm, property: "model", required: "" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-6" },
          [
            _c("csp-form-group-input", {
              attrs: {
                form: _vm.vehicleForm,
                property: "licensePlate",
                required: "",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-6" },
          [
            _vm.isComprehensiveClaimTypeSelected
              ? _c("csp-form-group-datepicker", {
                  attrs: {
                    form: _vm.vehicleForm,
                    property: "registrationDate",
                    required: "",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-6" },
          [
            _vm.isComprehensiveClaimTypeSelected
              ? _c("csp-form-group-input", {
                  attrs: {
                    form: _vm.vehicleForm,
                    property: "mileage",
                    required: "",
                    type: "number",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("csp-record-create-image-file-upload", {
        attrs: {
          "accepted-mime-types": "image/jpeg, image/png, application/pdf",
          "transform-mime-types": "image/jpeg, image/png",
          "upload-file-category-id": _vm.uploadFileCategory,
          "upload-label": "KFZ Schein",
          "upload-session-id": _vm.uploadSessionId,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }